<template>
  <div class="pos-wrapper vh-100 bg-light d-flex flex-column">
    <nav class="navbar navbar-dark bg-primary shadow-sm px-3">
      <span class="navbar-brand mb-0 h1"> {{ $t('POS') }}</span>
      <div class="d-flex align-items-center text-white">
        <div class="me-3 text-end">
                    {{ $t("shift") }}  :  {{ activeShift.shift_id }}
          </div>
          
      </div>
      <div class="d-flex align-items-center text-white">
        <div class="me-3 text-end text-white">
                      <router-link to="/sales/AllPOSReceipt" class="btn-download">
              <span class="text text-white">
                <i class="bi bi-clipboard-plus-fill"></i>
                {{ $t("bills") }}</span>
            </router-link>
          </div>

      </div>
    </nav>

    <div class="row g-0 flex-grow-1 ">

      <div class="col-md-1 bg-white border-end shadow-sm d-flex flex-column py-2 overflow-auto">
        <button class="btn category-btn mb-2 mx-2 border-0"
          :class="activeCategory === 'all' ? 'btn-primary' : 'btn-light text-muted'" @click="activeCategory = 'all'">
          <div class="small fw-bold">ALL</div>
        </button>

        <button v-for="cat in categories" :key="cat.id" @click="activeCategory = cat.category"
          class="btn category-btn mb-2 mx-2 border-0"
          :class="activeCategory === cat.id ? 'btn-primary' : 'btn-light text-muted'">
          <div class="small fw-bold text-uppercase">{{ cat.category }}</div>
        </button>
      </div>

      <div class="col-md-7 p-3 overflow-auto">
        <div class="mb-3">
          <div class="input-group shadow-sm">
            <span class="input-group-text bg-white border-end-0">
              <i class="bi bi-upc-scan"></i>
            </span>
            <input type="text" class="form-control border-start-0 ps-0" placeholder="Scan Barcode or Type SKU..."
              v-model="barcodeQuery" @keyup.enter="handleBarcode" ref="barcodeInput">
          </div>
        </div>

        <div class="mb-3">
          <div class="input-group shadow-sm">
            <span class="input-group-text bg-white border-end-0">
              <i class="bi bi-search"></i>
            </span>
            <input type="text" class="form-control border-start-0 ps-0" placeholder="Search products by name..."
              v-model="searchQuery">
          </div>
        </div>

        <div class="row row-cols-2 row-cols-lg-4 g-3">
          <div v-for="product in filteredProducts" :key="product.sn" class="col">
            <div class="card h-100 border-0 shadow-sm product-card hvr-grow" @click="addToCart(product)">
              <div class="card-body p-1 text-center">
                <h6 class="card-title text-dark mb-1"> <small>{{ product.namear }}</small></h6>
                <p class="card-text text-primary fw-bold">{{ product.salep }} LE</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 bg-white border-start  flex-column shadow">
        <div class="p-1 border-bottom d-flex justify-content-between align-items-center">
          <h5 class="mb-0 fw-bold"><i class="bi bi-cart3 me-2"></i>Current Order</h5>
          <span class="badge bg-secondary">{{ cart.length }} Items</span>
        </div>

        <div class="p-2 border-bottom bg-light">
          <label for="">{{ $t("customer") }}</label>
          <div class="input-group mb-1">
            <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("name") }} :</label>
            <input type="text" class="form-control form-control-sm"  for="inputGroupSelect01"  v-model="customerName">
          </div>
          <div class="input-group mb-1">
            <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("mobile") }} :</label>
            <input type="tel" class="form-control form-control-sm" for="inputGroupSelect01"  v-model="customerMobile" @change="getcustomerdata()">
          </div>
          <div class="input-group mb-1">
            <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("address") }} :</label>
            <input type="text" class="form-control form-control-sm"  for="inputGroupSelect01" v-model="customerAddress">
          </div>
          <div class="input-group mb-1">
          <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("delivery") }} :</label>
            <input type="number" min="0" step="0.5" class="form-control form-control-sm" for="inputGroupSelect01" v-model.number="deliveryFee">
          </div>
          <div class="input-group mb-1">
            <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("comment") }} :</label>
            <input type="text" class="form-control form-control-sm" for="inputGroupSelect01" v-model="comment">
          </div>
          <div class="input-group mb-1">
            <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("payment") }} :</label>
            <select class="form-control form-control-sm" v-model="accountpayment">
              <option placeholder="Payment" v-for="value in accountspayment" :key="value" :value="value">
                {{ value.namear }}
              </option>
            </select>

          </div>
          <div class="input-group mb-1">
            <label class="input-group-text col-sm-3" for="inputGroupSelect01">{{ $t("type") }} {{ $t("transaction") }} :</label>
            <select class="form-control form-control-sm" v-model="accountprofite">
              <option placeholder="Payment" v-for="value in accountsprofite" :key="value" :value="value">
                {{ value.namear }}
              </option>
            </select>

          </div>

        </div>

        <div class="flex-grow-1 overflow-auto px-3 py-2">
          <div v-if="cart.length === 0" class="text-center py-2">
            <i class="bi bi-basket text-light display-1 d-block mb-3"></i>
            <p class="text-muted">No items selected yet.</p>
          </div>

<div v-for="item in cart" :key="item.sn" class="cart-item mb-3 p-2 bg-light rounded-3 shadow-sm border border-light-subtle">
  <div class="row g-2 align-items-center mb-2">
    <div class="col-4">
      <div class="fw-bold text-dark text-truncate small" :title="item.namear">{{ item.namear }}</div>
      <div class="text-primary fw-bold" style="font-size: 0.85rem;">{{ item.salep }} LE</div>
    </div>

    <div class="col-4">
      <div class="d-flex align-items-center bg-white rounded border border-light-subtle py-1 px-1">
        <button @click="updateQty(item.sn, -1)" class="btn btn-sm p-0 flex-grow-1 text-secondary fw-bold" type="button">-</button>
        <input class="form-control form-control-sm text-center p-0 border-0 fw-bold bg-transparent mx-1" 
               @change="updateQty(item.sn, 0)" 
               type="number" 
               v-model.number="item.quantity"
               style="max-width: 45px; font-size: 0.9rem;">
        <button @click="updateQty(item.sn, 1)" class="btn btn-sm p-0 flex-grow-1 text-secondary fw-bold" type="button">+</button>
      </div>
    </div>

    <div class="col-3 text-end fw-bold text-dark" style="font-size: 0.95rem;">
      {{ (item.salep * item.quantity).toFixed(2) }}
    </div>

    <div class="col-1 text-end">
      <button @click="removeItem(item.sn)" class="btn btn-link text-danger p-0 border-0 text-decoration-none" title="Delete Item" type="button">
        <i class="bi bi-trash fs-5"></i>
      </button>
    </div>
  </div>

  <div class="border-top pt-2 mt-2">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <small class="text-muted fw-bold d-flex align-items-center">
        <i class="bi bi-chat-left-text me-1"></i> : {{ $t('comment') }}
      </small>
      <button @click="initializeAndAddComment(item)" class="btn btn-xs btn-outline-primary px-2 py-0 border-0 rounded-pill" type="button">
        <i class="bi bi-plus-circle-fill me-1"></i>{{ $t('add') }}
      </button>
    </div>

    <div v-if="Array.isArray(item.comment) && item.comment.length > 0" class="pe-1" style="max-height: 120px; overflow-y: auto;">
      <div v-for="(value, index) in item.comment" :key="index" class="d-flex align-items-center gap-1 mb-1">
        <span class="text-secondary small ms-1">{{ index + 1 }}.</span>
        <input type="text" 
               v-model="value.comment" 
               class="form-control form-control-sm bg-white border-light-subtle px-2 py-1 flex-grow-1" >
        <button @click="item.comment.splice(index, 1)" class="btn btn-sm p-1 text-danger border-0" title="Remove Note" type="button">
          <i class="bi bi-x-circle"></i>
        </button>
      </div>
    </div>
    <div v-else class="text-muted text-center py-1 style-fallback-text">
      <small style="font-size: 0.75rem; font-style: italic;">No specific custom notes added.</small>
    </div>
  </div>
</div>
        </div>

        <div class="p-4 border-top bg-light">
          <div class="d-flex justify-content-between mb-1">
            <span class="text-muted">{{ $t('total') }}</span>
            <span>{{ cartTotal.toFixed(2) }} LE</span>
          </div>
          <!-- <div class="d-flex justify-content-between mb-1">
            <span class="text-muted">Tax (0%)</span>
            <span>{{ (cartTotal * 0).toFixed(2) }} LE</span>
          </div> -->
          <div class="d-flex justify-content-between mb-2">
            <span class="text-muted">{{ $t("delivery") }}</span>
            <span>{{ deliveryFee.toFixed(2) }} LE</span>
          </div>
          <div class="d-flex justify-content-between mb-4">
            <h4 class="fw-bold">{{ $t('total') }}</h4>
            <h4 class="fw-bold text-success">{{ totalWithDelivery.toFixed(2) }} LE</h4>
          </div>

          <div class="row g-2">
            <div class="col-6">
              <button class="btn btn-outline-secondary w-100 py-3" @click="clearCart">{{ $t('cancel') }}</button>
            </div>
            <div class="col-6">
              <button class="btn btn-success w-100 py-3 fw-bold shadow d-flex align-items-center justify-content-center" @click="submitOrder"
                :disabled="cart.length === 0 || isSubmitting">
                <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span>{{ isSubmitting ? 'PROCESSING...' :  $t('payment') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div id="receipt-print" class="d-none d-print-block">
    <!-- <div class="receipt-header text-center">
      <img class="log" :src="url" crossorigin="anonymous" />
      <h3>{{ pname }}</h3>
      <p>
        Date: {{ new Date().toLocaleString() }}</p>
      <hr/>
      <strong> {{ $t("invoiceNumber") }} : {{ recid }} </strong>
    </div>
<hr class="dashed-line"> -->

      <div class="receipt-header text-center">
        <img class="log mb-2" :src="url" crossorigin="anonymous" />
        <h3 class="fw-bold mb-1 receipt-title">{{ pname }}</h3>
        <p class="text-muted small receipt-metadata mb-0">
          <!-- {{ $t("invoiceNumber") }} : {{ receiptId }}<br> -->
          Date: {{ new Date().toLocaleString() }}
        </p>
        <strong> {{ $t("invoiceNumber") }} : {{ recid }} </strong>
      </div>

<table class="table table-bordered table-sm border-2 border-dark w-100 customer-info-table align-middle mb-2" style="font-size: 0.85rem;">
  <tbody>
    <tr class="border-2 border-dark">
      <td class="fw-bold bg-light py-1 border-2 border-dark" style="width: 35%;">{{ $t('customer') }}</td>
      <td class="fw-bold py-1 border-2 border-dark">{{ customerName || '-' }}</td>
    </tr>

    <tr v-if="customerMobile" class="border-2 border-dark">
      <td class="fw-bold bg-light py-1 border-2 border-dark">{{ $t('mobile') }}</td>
      <td class="fw-bold py-1 border-2 border-dark">{{ customerMobile }}</td>
    </tr>

    <tr v-if="customerAddress" class="border-2 border-dark">
      <td class="fw-bold bg-light py-1 border-2 border-dark">{{ $t('address') }}</td>
      <td class="fw-bold text-wrap py-1 border-2 border-dark">{{ customerAddress }}</td>
    </tr>

    <tr v-if="accountpayment.namear" class="border-2 border-dark">
      <td class="fw-bold bg-light py-1 border-2 border-dark">{{ $t('payment') }}</td>
      <td class="fw-bold py-1 border-2 border-dark">{{ accountpayment.namear }}</td>
    </tr>

    <tr v-if="accountprofite.namear" class="border-2 border-dark">
      <td class="fw-bold bg-light py-1 border-2 border-dark">{{ $t("type") }} {{ $t("transaction") }}</td>
      <td class="fw-bold py-1 border-2 border-dark">{{ accountprofite.namear }}</td>
    </tr>

    <!-- <tr v-if="comment" class="border-2 border-dark">
      <td class="fw-bold bg-light py-1 border-2 border-dark">{{ $t("comment") }}</td>
      <td class="text-wrap py-1 border-2 border-dark">{{ comment }}</td>
    </tr> -->
  </tbody>
</table>

      <div class="mt-3 p-2 bg-light border rounded text-center small text-muted receipt-note">
        <strong>{{ $t("comment") }} : {{ comment }} </strong>
      </div>


  <hr class="dashed-line">

<table class="table table-bordered w-100 receipt-table align-middle">
  <thead class="table-light">
    <tr>
      <th style="width: 45%;">{{ $t('item') }}</th>
      <th class="text-center" style="width: 15%;">{{ $t('quantity') }}</th>
      <th class="text-center" style="width: 20%;">{{ $t('price') }}</th>
      <th class="text-end" style="width: 20%;">{{ $t('total') }}</th>
    </tr>
  </thead>
  <tbody>
    <template v-for="item in cart" :key="item.sn">
      <tr>
        <td class="fw-bold text-wrap text-dark py-2">{{ item.namear }}</td>
        <td class="text-center text-secondary py-2">{{ item.quantity }}</td>
        <td class="text-center text-secondary py-2">{{ item.salep }}</td>
        <td class="text-end fw-semibold text-dark py-2">
          {{ (item.salep * item.quantity).toFixed(2) }}
        </td>
      </tr>
      
      <tr v-if="Array.isArray(item.comment) && item.comment.length > 0" class="table-light-subtle">
        <td colspan="4" class="p-2 bg-light-subtle">
          <div class="receipt-notes-container ps-3 text-muted border-start border-2 border-secondary" style="font-size: 0.8rem;">
            <div v-for="(note, idx) in item.comment" :key="idx" class="text-wrap">
              <strong v-if="note.comment.trim()">• {{ note.comment }}</strong>
            </div>
          </div>
        </td>
      </tr>
    </template>
  </tbody>
</table>

    <hr>
    <div class="totals">
      <div class="d-flex justify-content-between">
        <span>{{ $t("total") }} :</span> <span>{{ cartTotal.toFixed(2) }} LE</span>
      </div>
      <!-- <div class="d-flex justify-content-between">
        <span>Tax (0%):</span> <span>{{ (cartTotal * 0).toFixed(2) }} LE</span>
      </div> -->
      <div class="d-flex justify-content-between">
        <span>{{ $t("delivery") }} :</span> <span>{{ deliveryFee.toFixed(2) }} LE</span>
      </div>
      <div class="d-flex justify-content-between fw-bold">
        <span>{{ $t("total") }} :</span> <span>{{ totalWithDelivery.toFixed(2) }} LE</span>
      </div>
    </div>
    

      <hr class="dashed-line" />
      <p class="text-center mt-3 mb-1 fw-bold small text-uppercase tracking-wider footer-thanks">Thank you for your visit!</p>
    
  </div>


</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import store from '@/store';
// --- State Management ---
const activeCategory = ref('all');
const categories = ref([]);
const products = ref([]);
const cart = ref([]);

const customerName = ref('');
const customerMobile = ref('');
const customerAddress = ref('');
// Track delivery cost reactively
const deliveryFee = ref(0);

const barcodeQuery = ref('');
const barcodeInput = ref(null);
const searchQuery = ref(''); 

const url = ref(store.state.imgurl + `/clogo/${store.state.cnum[0].cnum}.png`);
const pname = ref(store.state.cnum[0].cname);
const recid = ref("");
const accountspayment = ref([])
const accountsprofite = ref([])
const accountpayment = ref({})
const accountprofite = ref({})
const comment = ref("")
const isSubmitting = ref(false);
const activeShift = ref({})
// --- Data Fetching ---
const fetchData = async () => {
  try {

    const response = await axios.get(`/pos/getactiveshift`);
    
    const resCats = await axios.get('/data/allproductcategories');
    const resProds = await axios.get('/data/allposproducts');
    const result2 = await axios.get("/data/accountpayment");
    const result3 = await axios.get("/data/accountprofite");
    if (response.data.data.length > 0) {
          // An active shift exists! Populate the state to restore their session
          activeShift.value = response.data.data[0];
        }else{
          activeShift.value = null
          alert("برجاء الرجوع الى مدير الوردية")
          
        }

    
    if (result2.status == 200) {
      accountspayment.value = result2.data.data;
      accountsprofite.value = result3.data.data;
    }
    categories.value = resCats.data.data
    products.value = resProds.data.data
  } catch (error) {
    console.error("Error loading POS data:", error);
  }
};


// --- Logic ---
const filteredProducts = computed(() => {
  let tempProducts = products.value;

  if (activeCategory.value !== 'all') {
    tempProducts = tempProducts.filter(p => p.item === activeCategory.value);
  }

  if (searchQuery.value.trim() !== '') {
    const query = searchQuery.value.toLowerCase();
    tempProducts = tempProducts.filter(p =>
      p.namear.toLowerCase().includes(query) ||
      (p.nameen && p.nameen.toLowerCase().includes(query)) 
    );
  }

  return tempProducts;
});

const cartTotal = computed(() => {
  return cart.value.reduce((sum, item) => sum + (item.salep * item.quantity), 0);
});

const cartTotalcost = computed(() => {
  return cart.value.reduce((sum, item) => sum + (item.buyp * item.quantity), 0);
});

// Computed total logic factoring in delivery fee seamlessly
const totalWithDelivery = computed(() => {
  return cartTotal.value + (Number(deliveryFee.value) || 0);
});

const addToCart = (product) => {
  const existing = cart.value.find(i => i.sn === product.sn);
  if (existing) {
    existing.quantity++;
  } else {
    // Force standard array syntax configuration
    cart.value.push({ 
      ...product, 
      quantity: 1, 
      comment: [] // Initialize as an empty array ready for inputs
    });
  }
};

// Add this wrapper function to template actions block
const initializeAndAddComment = (item) => {
  if (!Array.isArray(item.comment)) {
    item.comment = [];
  }
  item.comment.push({ comment: '' });
};

const updateQty = (sn, delta) => {
  const item = cart.value.find(i => i.sn === sn);
  if (item) {
    item.quantity += delta;
    if (item.quantity <= 0) {
      removeItem(sn);
    }
  }
};

// NEW FUNCTION: Direct removal from cart
const removeItem = (sn) => {
  cart.value = cart.value.filter(i => i.sn !== sn);
};

const clearCart = () => {
  if (confirm("Clear current order?")) {
    cart.value = [];
    deliveryFee.value = 0; // Reset delivery cost clear
  }
};

const submitOrder = async () => {
  if (accountpayment.value && accountprofite.value && activeShift.value) {
    isSubmitting.value = true;
    try {
      const payload = {
        customer: {
          name: customerName.value,
          mobile: customerMobile.value,
          address: customerAddress.value
        },
        description : comment.value,
        items: cart.value.map(item => ({
          pid: item.sn,
          name: item.namear,
          qty: item.quantity,
          price: item.salep,
          cost:item.buyp,
          subtotal: item.salep * item.quantity,
          costtotal: item.buyp * item.quantity,
          comment:item.comment
        })),
        tax: Number(cartTotal.value * 0).toFixed(2),
        delivery_fee: Number(deliveryFee.value).toFixed(2), // Appended delivery property to API backend object
        total: Number(totalWithDelivery.value).toFixed(2), // Updates structure payload value definition logic
        cartTotalcost: Number(cartTotalcost.value).toFixed(2),
        timestamp: new Date().toISOString(),
        payment: accountpayment.value,
        saletype: accountprofite.value,
        shift_id:activeShift.value.shift_id
      };

      const confirm = await axios.post('/pos/createposreceipt', payload);
      recid.value = confirm.data.data

      alert("Order Submitted Successfully!");
      setTimeout(() => {
        window.print();

        cart.value = [];
        customerName.value = '';
        customerMobile.value = '';
        customerAddress.value = '';
        deliveryFee.value = 0; // Cleared status
        accountpayment.value = '';
        accountprofite.value = '';
        comment.value = ''
      }, 500);
    } catch (error) {
      alert("Checkout Failed");
    }finally{
      isSubmitting.value = false;
    }
  } else {
    alert("Please select a payment method")
  }
};

const getcustomerdata = async () => {
  const confirm = await axios.get(`/pos/getcustomerdata/${customerMobile.value}`);
  if (confirm.data.data.length >0 && confirm.status == 200) {
    customerName.value = confirm.data.data[0].customer_name
    customerAddress.value = confirm.data.data[0].customer_address
  }
}

const handleBarcode = () => {
  const code = barcodeQuery.value.trim();
  if (!code) return;

  const product = products.value.find(p => p.barcode === code || p.sku === code);

  if (product) {
    addToCart(product);
    barcodeQuery.value = ''; 
  } else {
    alert("Product not found!");
    barcodeQuery.value = '';
  }
};

onMounted(() => {
  fetchData();
  barcodeInput.value?.focus();
});
</script>

<style scoped>

.receipt-table th {
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.receipt-table tbody tr:not(:last-child) {
  border-bottom: 1px dashed #f0f0f0; /* Soft separator between different items */
}

/* .receipt-table td {
  vertical-align: top;
  padding-top: 4px;
  padding-bottom: 4px;
} */
.text-wrap {
  white-space: normal !important;
  word-break: break-word;
}
.receipt-notes-container {
  line-height: 1.2;
  margin-top: 2px;
}
/* Style section kept intact from your setup */
.pos-wrapper {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  user-select: none;
}
.category-btn {
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  transition: all 0.2s ease;
}
.product-card {
  cursor: pointer;
  border-radius: 15px;
  transition: transform 0.1s ease;
}
.product-card:active {
  transform: scale(0.95);
  background-color: #e9ecef;
}
.cart-item {
  border: 1px solid transparent;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}
@media print {
  body * { visibility: hidden; }
  #receipt-print, #receipt-print * { visibility: visible; }
  #receipt-print {
    position: absolute; left: 0; top: 0; width: 80mm; padding: 5mm; font-size: 12px; line-height: 1.2; color: #000;
  }
  @page { margin: 0; }
  .d-print-block { display: block !important; }
  html, body { height: auto !important; margin: 0 !important; padding: 0 !important; overflow: visible !important; }
  .pos-wrapper, .navbar, .row { display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important; }
}
.receipt-table { font-size: 0.85rem; border-collapse: collapse; }
.receipt-table th { border-bottom: 1px dashed #000; }
.log { width: 70mm; align-items: center; }
</style>